module.exports = __webpack_public_path__ + "static/media/comment.626bd0d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/schedule/comment.png
// module id = 2102
// module chunks = 6